
import React from 'react';
import { COMMON_TEXT_COLOR } from '../constants';
import cx from 'classnames';
import { NextIconSvg, PrevIconSvg } from '../components/Common/Assets/SvgComponent/commonSvgIcon';



const SampleNextArrow = (props) => {
    const { className, onClick, isSearchPage } = props;
    return (
        <div className={cx(className, !isSearchPage ? 'homeSwiperNavigationBtn homeSwiperNavigationNextBtn' : 'searchPageSwiperNavigationBtn searchPageSwiperNavigationNextBtn')} onClick={onClick} >
            <NextIconSvg className='commonSwiperNavIcon' />
        </div>
    )
}

const SamplePrevArrow = (props) => {
    const { className, onClick, isSearchPage } = props;
    return (
        <div className={cx(className, !isSearchPage ? 'homeSwiperNavigationBtn homeSwiperNavigationPrevBtn' : 'searchPageSwiperNavigationBtn searchPageSwiperNavigationPrevBtn')} onClick={onClick}>
            <PrevIconSvg className='commonSwiperNavIcon' />
        </div>
    );
}

const listingImageNextArrowStyle = {
    right: '5px',
    color: COMMON_TEXT_COLOR, zIndex: '1', width: '34px', height: '34px', top: '50%',
    fontSize: '18px', cursor: 'pointer', textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, 0.9)', backgroundRepeat: 'repeat-x',
    filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr="#00000000",endColorstr="#80000000",GradientType=1)',
    borderRadius: '50%', position: 'absolute'
};

const listingImagePrevArrowStyle = {
    left: '5px',
    color: COMMON_TEXT_COLOR, zIndex: '1', width: '34px', height: '34px', top: '50%',
    fontSize: '18px', cursor: 'pointer', textAlign: 'center', backgroundColor: 'rgba(255, 255, 255, 0.9)', backgroundRepeat: 'repeat-x',
    filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr="#80000000",endColorstr="#00000000",GradientType=1)',
    borderRadius: '50%', position: 'absolute'
};

const ListingImageNextArrow = (props) => {
    const { className, onClick } = props
    return (
        <div
            className={className}
            style={listingImageNextArrowStyle}
            onClick={onClick}
        >
            <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false"
                style={{ height: '13px', width: '13px', display: 'block', fill: '#282828', position: 'absolute', top: '31%', right: '10px' }}>
                <path d="m4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z"></path>
            </svg>
        </div>
    );
}

const ListingImagePrevArrow = (props) => {
    const { className, onClick } = props
    return (
        <div
            className={className}
            style={listingImagePrevArrowStyle}
            onClick={onClick}
        >
            <svg viewBox="0 0 18 18" role="img" aria-label="Previous" focusable="false"
                style={{ height: '13px', width: '13px', display: 'block', fill: '#282828', position: 'absolute', top: '31%', left: '10px' }}>
                <path d="m13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z"></path>
            </svg>
        </div>
    );
}

export { SampleNextArrow, SamplePrevArrow, ListingImageNextArrow, ListingImagePrevArrow }